export * from 'server/models/SaveImageRequest';


// WEBPACK FOOTER //
// ./data/models/SaveImageRequest.ts